export interface Stablecoin {
  symbol: string;
  name: string;
  contractAddress: string;
}

export interface BlockchainNetwork {
  id: string;
  name: string;
  rpcUrl: string;
  explorerUrl: string;
  stablecoins: Stablecoin[];
  icon: string; // Emoji or SVG path
}

export const networks: BlockchainNetwork[] = [
  {
    id: 'ethereum',
    name: 'Ethereum',
    // Note: We use Etherscan API for transaction history instead of direct RPC
    rpcUrl: 'https://api.etherscan.io/api',
    explorerUrl: 'https://etherscan.io',
    icon: 'Ξ',
    stablecoins: [
      { symbol: 'USDC', name: 'USD Coin', contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48' },
      { symbol: 'USDT', name: 'Tether', contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7' },
    ],
  },
  {
    id: 'solana',
    name: 'Solana',
    rpcUrl: 'https://api.mainnet-beta.solana.com',
    explorerUrl: 'https://explorer.solana.com',
    icon: 'S', // Using 'S' as a placeholder for Solana icon
    stablecoins: [
      { symbol: 'USDC', name: 'USD Coin', contractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyB7uH' },
    ],
  },
  {
    id: 'polygon',
    name: 'Polygon',
    rpcUrl: 'https://polygon-rpc.com/',
    explorerUrl: 'https://polygonscan.com',
    icon: 'P', // Using 'P' as a placeholder for Polygon icon
    stablecoins: [
      { symbol: 'USDC', name: 'USD Coin (PoS)', contractAddress: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' },
      { symbol: 'USDT', name: 'Tether', contractAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F' },
    ],
  },
];

export const getNetworkById = (id: string) => networks.find(n => n.id === id); 